import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  Briefcase, Building, UserPlus, Edit, Trash2,
  Eye, Mail, Phone, Award, Play, Pause, Key
} from 'lucide-react';
import { STATUS_CONFIG } from './constants';

function getStatusBadge(status) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.actif;
  const Icon = config.icon;
  return <Badge className={`${config.color} text-white`}><Icon className="h-3 w-3 mr-1" />{config.label}</Badge>;
}

export default function ExpertsTab({
  filteredExperts, setShowCreateExpertModal, setSelectedItem, setShowDetailModal,
  openEditExpert, updateExpertStatus, deleteExpert, openResetPasswordModal
}) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {filteredExperts.map((expert) => (
          <Card key={expert.id} className="hover:shadow-lg transition-all" data-testid={`expert-card-${expert.id}`}>
            <CardHeader className="pb-2">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center text-lg font-bold text-orange-700">
                    {(expert.prenom?.[0] || '') + (expert.nom?.[0] || '')}
                  </div>
                  <div>
                    <CardTitle className="text-base">{expert.prenom} {expert.nom}</CardTitle>
                    <p className="text-sm text-gray-500">{expert.specialite || 'Généraliste'}</p>
                  </div>
                </div>
                {getStatusBadge(expert.statut || 'actif')}
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 text-gray-600"><Mail className="h-4 w-4" /><span className="truncate">{expert.email}</span></div>
                {expert.telephone && <div className="flex items-center gap-2 text-gray-600"><Phone className="h-4 w-4" /><span>{expert.telephone}</span></div>}
                {expert.numero_agrement && <div className="flex items-center gap-2 text-gray-600"><Award className="h-4 w-4" /><span>N° {expert.numero_agrement}</span></div>}
                {expert.coopers && <div className="flex items-center gap-2 text-gray-600"><Building className="h-4 w-4" /><span>{expert.coopers.nom} {expert.coopers.prenom}</span></div>}
              </div>
              <div className="flex flex-wrap gap-1 mt-4 pt-3 border-t">
                <Button size="sm" variant="ghost" onClick={() => { setSelectedItem(expert); setShowDetailModal(true); }}><Eye className="h-4 w-4" /></Button>
                <Button size="sm" variant="ghost" onClick={() => openEditExpert(expert)}><Edit className="h-4 w-4" /></Button>
                {expert.statut === 'suspendu' || expert.statut === 'inactif' ? (
                  <Button size="sm" variant="ghost" className="text-green-600" onClick={() => updateExpertStatus(expert.id, 'actif')} title="Activer"><Play className="h-4 w-4" /></Button>
                ) : (
                  <Button size="sm" variant="ghost" className="text-orange-600" onClick={() => updateExpertStatus(expert.id, 'suspendu')} title="Suspendre"><Pause className="h-4 w-4" /></Button>
                )}
                <Button size="sm" variant="ghost" className="text-blue-600" onClick={() => openResetPasswordModal(expert, 'expert')} title="Réinitialiser le mot de passe"><Key className="h-4 w-4" /></Button>
                <Button size="sm" variant="ghost" className="text-red-600" onClick={() => deleteExpert(expert.id)} title="Supprimer"><Trash2 className="h-4 w-4" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      {filteredExperts.length === 0 && (
        <Card>
          <CardContent className="py-12 text-center">
            <Briefcase className="h-12 w-12 mx-auto text-gray-300 mb-4" />
            <p className="text-gray-500">Aucun expert trouvé</p>
            <Button className="mt-4" onClick={() => setShowCreateExpertModal(true)}><UserPlus className="h-4 w-4 mr-2" />Créer un expert</Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
